<div class="shell">
	<header class="shell__header">
		<h1>youtubeDownloader</h1>
	</header>
	<main class="shell__main">
		<section class="shell__panel" id="download-form"></section>
		<section class="shell__panel" id="queue-panel"></section>
	</main>
</div>
